import { create } from 'zustand'

export interface PendingOperation {
  operationId: number
  username: string
  platform: string
  startedAt: number
}

interface ScrapeOperationStore {
  pendingOperations: PendingOperation[]
  lastCompletedAt: number | null
  addOperation: (op: PendingOperation) => void
  removeOperation: (operationId: number) => void
  markCompleted: (operationId: number) => void
  clearAll: () => void
}

const useScrapeOperationStore = create<ScrapeOperationStore>((set) => ({
  pendingOperations: [],
  lastCompletedAt: null,

  addOperation: (op) =>
    set((state) => ({
      pendingOperations: [...state.pendingOperations, op]
    })),

  removeOperation: (operationId) =>
    set((state) => ({
      pendingOperations: state.pendingOperations.filter(
        (op) => op.operationId !== operationId
      )
    })),

  markCompleted: (operationId) =>
    set((state) => ({
      pendingOperations: state.pendingOperations.filter(
        (op) => op.operationId !== operationId
      ),
      lastCompletedAt: Date.now()
    })),

  clearAll: () => set({ pendingOperations: [] })
}))

export default useScrapeOperationStore
